import React, { useState, useEffect, useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO, format } from 'date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import DetailTable from './DetailTable';
import { useTranslation } from "react-i18next";
import { alpha } from '@material-ui/core/styles';
import PermissionContext from '../../contexts/PermissionContext';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(18),
		maxWidth: 950,
		margin: 'auto',
		overflow: 'hidden',
		backgroundColor: 'white'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {

		margin: theme.spacing(3, 2, 2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));


const endpoint = `payment`
const purchaseEndpoint = `purchase/pending`
const bankEndpoint = `bank`
const paymentMethodEndpoint = `payment-method`	
const DATE_FORMAT = 'yyyy-MM-dd';

const PaymentForm = React.forwardRef((props, ref) => {
	const { t } = useTranslation();
	const { idToUpdate, permission } = props;

	const {userHasPermission} = useContext(PermissionContext)
  
	// console.log("UHP",userHasPermission)
	
	let hasPerm = userHasPermission(permission, 'can_list')
	let hasAddPerm = userHasPermission(permission, 'can_post')
	let hasEditPerm = userHasPermission(permission, 'can_patch')
	let hasGetPerm = userHasPermission(permission, 'can_get')
	let hasDeletePerm = userHasPermission(permission, 'can_delete')
	// for detail form    
	let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')

	const [paymentId, setPaymentId] = useState(props.idToUpdate)
	useEffect(() => {
		let isActive = true;
		return () => { isActive = false };
	}, [paymentId, setPaymentId]);
	const [selectedDate, setSelectedDate] = useState(new Date());	


	const [bankData, setBankData] = useState([]);
	useEffect(() => {

		retrieveBankData()
	}, []);

	const retrieveBankData = () => {
		DataService.getAll(bankEndpoint)
			.then(response => {
				setBankData(response.data)
				// console.log("bank",response.data);
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	const [paymentMethodData, setPaymentMethodData] = useState([]);
	useEffect(() => {

		retrievePaymentMethodData()
	}, []);

	const retrievePaymentMethodData = () => {
		DataService.getAll(paymentMethodEndpoint)
			.then(response => {
				setPaymentMethodData(response.data)
				// console.log("paymentMethod",response.data);
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	// Getting Purchase data only once at the beggining
	const [purchaseData, setPurchaseData] = useState([]);
	useEffect(() => {

		retrievePurchaseData()
	}, []); // Those ARE connectec

	const retrievePurchaseData = () => {
		DataService.getAll(purchaseEndpoint)
			.then(response => {
				setPurchaseData(response.data)
				// console.log(response.data);
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}


	const [descriptionValue,setDescriptionValue] = useState("")		
	

	//purchase combobox values
	const [purchaseValue, setPurchaseValue] = React.useState(purchaseData[0]);
	const [purchaseInputValue, setPurchaseInputValue] = React.useState('');	
	const [totalValue, setTotalValue] = React.useState(0.00);

	// INFO NOTIFICATION VARS
	const [infoOpen, setInfoOpen] = useState(false);
	const [infoTitle, setInfoTitle] = useState('');
	const [infoBody, setInfoBody] = useState('');
	//***********************

	//Dialog Vars
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogueTitle, setDialogueTitle] = useState('');
	const [dialogueBody, setDialogueBody] = useState('');
	//**********

	// DIALOG FUNCTIONS 
	const handleDialogOk = () => {
		setDialogOpen(false)
	};

	const handleDialogClose = () => {
		setDialogOpen(false)
	};

	const openDialogBox = (title, body) => {
		setDialogueTitle(title)
		setDialogueBody(body)
		setDialogOpen(true)
	};
	//*******************

	// Notification INFO functions
	const openNoticeBox = (title, body) => {
		setInfoTitle(title)
		setInfoBody(body)
		setInfoOpen(true)
	};

	const handleInfoClose = () => {
		setInfoOpen(false)
	};
	// *****************

	
	const [data, setData] = useState([]);
	useEffect(() => {
		let id = typeof idToUpdate === 'object' ? 0 : idToUpdate
		getData(id)
	}, []);

	const getData = (id) => {
		DataService.get(id, endpoint)
			.then(response => {
				// console.log("get data",response.data)		
				setPaymentId(response.data.id)
				setTotalValue(response.data.total)		
				setSelectedDate(parseISO(response.data.date))				
				setPurchaseInputValue(response.data.purchase)
				setPurchaseValue(response.data.purchase)				
				setDescriptionValue(response.data.description)				
			})
			.catch(e => {
				console.log(e)
				if (e.response.status !== 404) {
					openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
				} else {
					// setData({})
					console.log("Unexpected error: ", e)
				}

			});
	}

	const updateData = (values) => {
		DataService.update(endpoint, values)
			.then(response => {
				openNoticeBox("Notice", t("record_updated_successfully", {"table": t("payment_table_title")}))
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	const addData = (values) => {
		DataService.create(`${endpoint}/`, values)
			.then(response => {
				openNoticeBox("Notice", t("record_created_successfully", {"table": t("payment_table_title")}))
				setPaymentId(response.data.id)				
			})
			.catch(e => {
				openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
			});
	}

	const submitForm = (event) => {
		event.preventDefault();
		var newDate,newDueDate = ""
		newDate = format(selectedDate, DATE_FORMAT)		
		let values = {
			'purchase_id': purchaseValue.id,
			'date': newDate,						
			'description': descriptionValue			
		}
		if (paymentId === 0) {
			addData(values)			
		}
		if (paymentId > 0) {
			values.id = paymentId
			// console.log(values)
			updateData(values)
		}
		// console.log("submit ",values)	

	}

	const handleReset = (event) => {

	}

	const classes = useStyles();

	return (
		<Paper className={classes.paper}>
			<CssBaseline />
			<GenericDialogBox
				opn={dialogOpen}
				handleDialogOk={handleDialogOk}
				handleDialogClose={handleDialogClose}
				title={dialogueTitle}
				body={dialogueBody} />
			<InfoBox
				opn={infoOpen}
				handleDialogClose={handleInfoClose}
				title={infoTitle}
				body={infoBody} />

			<form className={classes.form} onSubmit={submitForm} onReset={handleReset}>
				<Grid container spacing={2}>
					<Grid item xs={4}>
						<Typography variant="h4" component="h4">
							{t("payment_form_payment_id")}: {paymentId ? paymentId : 0}
						</Typography>
						<Autocomplete
							id="purchase"
							// value={value}
							options={purchaseData}
							getOptionLabel={(option) => option.invoice ? option.invoice : "-"}
							onChange={(event, newValue) => {								
								setPurchaseValue(newValue);
							}}
							inputValue={purchaseInputValue}
							onInputChange={(event, newInputValue) => {
								setPurchaseInputValue(newInputValue);
							}}

							value={purchaseValue ? purchaseValue : ""}
							renderInput={(params) => <TextField {...params} label={t("payment_form_lbl_payment_purchase")} variant="outlined" />}
							getOptionSelected={(option, value) => option.value === value.value}
							style={{ marginTop: '15px' }}
						/>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								clearable="true"
								value={selectedDate}
								placeholder="2021-07-07"
								onChange={date => setSelectedDate(date)}
								// minDate={new Date()}
								format={DATE_FORMAT}
								autoOk
								name="date"
								id="date"
								variant="inline"
								inputVariant="outlined"
								style={{ marginTop: '5px' }}
							/>							
						</MuiPickersUtilsProvider>						
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="description"
							label={t("payment_form_lbl_payment_description")}
							name="description"
							multiline
          					maxRows={4}
							onChange={event => setDescriptionValue(event.target.value)}
							value={descriptionValue}
							style={{ marginTop: '5px' }}
						/>						
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="total"
							label={t("payment_form_lbl_payment_total")}
							name="total"
							onChange={event => setTotalValue(event.target.value)}
							value={totalValue}
							disabled={true}
							style={{ marginTop: '1px' }}
						/>
					</Grid>
					<Grid item xs={8}>
						<DetailTable
							paymentId={paymentId}
							setPaymentId={setPaymentId}													
							purchaseData={purchaseValue}
							bankData={bankData}						
							setBankData={setBankData}	
							paymentMethodData={paymentMethodData}
							setPaymentMethodData={setPaymentMethodData}
							permission={permission}
						/>
					</Grid>
					<Grid item xs={12}>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							disabled = {paymentId === 0 ? false : !hasAddPerm ? true : !hasEditPerm ? true : false}
						>
							{paymentId === 0 ? t("save_form_button") : t("update_form_button")}

						</Button>
					</Grid>
				</Grid>
			</form>
			<Box mt={8}>

			</Box>

		</Paper>
	)
})

export default PaymentForm;
    // ReactDOM.render(<WithMaterialUI />, document.getElementById('root'));
